export enum ClaimAccessType {
	ARTIST = 'Artist',
	MANAGER = 'Manager',
	LABEL = 'Label',
	PROVIDER = 'Provider',
}

export type PostAuth = {
	data: null | string | {message: string};
	errors?: {status: string; title: string; code: string; detail: string}[];
};

export type DecodedTokenType = {
	email: string;
	name: string;
	stakeholderType: number;
	iat: number;
	exp: number;
};

export type DecodedResetTokenType = {
	iat: number;
	uid: number;
	exp: number;
};

export enum AuthProvider {
	OKTA = 'DeezerOkta',
	BASIC = 'Basic',
}

export type OktaAuth =
	| {
			authProvider: AuthProvider.OKTA;
			oktaUrl: string;
	  }
	| {
			authProvider: AuthProvider.BASIC;
	  };
